// extracted by mini-css-extract-plugin
module.exports = {"applyFilterButton":"ReportingDashboardAdditionalFilters_applyFilterButton__2vdkw","productInput":"ReportingDashboardAdditionalFilters_productInput__2d2MC"};